import React, { Fragment, useMemo } from 'react';
import { ArrowNarrowLeftIcon } from '@zola/zola-ui/src/components/SvgIconsV3/ArrowNarrowLeft';
import Schemas from '@zola/zola-ui/src/components/Schemas/Schemas';
import { getBreadcrumbsSchema } from '@zola-helpers/client/dist/es/schema';
import PropTypes from 'prop-types';

export const MenuItem = ({ category, active }) => {
  const href = category?.url || `/shop/category/${category.key}`;
  return active ? (
    <span className="category-grid-nav-menus-item">{category.name}</span>
  ) : (
    <a className="category-grid-nav-menus-item" href={href}>
      {category.name}
    </a>
  );
};

const CategoryPropType = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
});

MenuItem.propTypes = {
  category: CategoryPropType,
  active: PropTypes.bool,
};

export const MobileBack = ({ category }) => {
  const href = category.url || `/shop/category/${category.key}`;
  return (
    <a className="category-grid-nav-menus-item" href={href}>
      <ArrowNarrowLeftIcon style={{ transform: 'scale(1,1)' }} />
      {category.name}
    </a>
  );
};

MobileBack.propTypes = {
  category: CategoryPropType,
};

export const CategoryGridNav = ({ menus = [], activeCategoryKey }) => {
  const breadcrumbList = useMemo(
    () =>
      menus.map((item) => ({
        to: item.url || `/shop/category/${item.key}`,
        label: item.name,
      })),
    [menus]
  );

  if (menus.length === 0) return null;
  const parentCategory = menus[menus.length - 2];

  return (
    <>
      <Schemas schemas={getBreadcrumbsSchema(breadcrumbList)} />
      {!!parentCategory && (
        <div className="category-grid-nav-menus-mobile">
          <MobileBack category={parentCategory} />
        </div>
      )}
      <div className="category-grid-nav-menus-desktop">
        {menus.map((item, index) => (
          <Fragment key={item.key}>
            <MenuItem key={item.key} category={item} active={item.key === activeCategoryKey} />
            {index !== menus.length - 1 && <span className="category-grid-nav-menus-slash">/</span>}
          </Fragment>
        ))}
      </div>
    </>
  );
};

CategoryGridNav.propTypes = {
  activeCategoryKey: PropTypes.string,
  menus: PropTypes.arrayOf(CategoryPropType),
};

export default CategoryGridNav;
